module.exports = __webpack_public_path__ + "img/nitrogen.baf981ce.png";